import React, { Component } from 'react';
import { Container } from 'react-grid-system';
import { connect } from 'react-redux';
import { RouteProps } from 'react-router-dom';
import { ClientModel } from '../../entities/client.model';
import store from '../../store';
import StoreProducts from './store-products';
import './store.scss';

interface SearchProps {
  client: ClientModel;
  products: any,
  match: any,
  history: any
}

interface SearchState {
  hasSearch: boolean;
}

const mapStateToProps = (state: any) => {
  return {
    products: state.products,
    client: state.client
  }
}

class StorePage extends Component<SearchProps & RouteProps, SearchState> {

  menuList = [
    { text: "Байгууллага +", route: "/store/client-company" }
  ];

  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0, 0)
      store.dispatch({ type: 'REFRESH_PRODUCTS' })
    });
  }

  render() {
    return (
      <div className="page store-page">
        {/* <div className="store-menu">
          {this.menuList.map((menuItem, index) => (
            <Link key={index} to={menuItem.route} className="menu-item ui button">
              {menuItem.text}
            </Link>
          ))}
        </div> */}
        <div className="full-width text-center">
          <h1>Дэлгүүр</h1>
        </div>
        <Container fluid={true} className="store-page-container" id="page-container">
          <StoreProducts products={this.props.products} client={this.props.client}></StoreProducts>
        </Container>
      </div>
    );
  }
}

export default connect(mapStateToProps)(StorePage);